import { Slot } from '@radix-ui/react-slot';
import { ButtonHTMLAttributes, ReactNode } from 'react';

import { RegularChevronRight, RegularEllipsis } from '@/icons/components';
import { twJoin } from '@/utils/tw-merge';

export const Pagination = ({
  children,
  ariaLabel,
}: {
  children: ReactNode;
  ariaLabel: string;
}) => {
  return (
    <nav role="navigation" aria-label={ariaLabel} className="flex gap-2">
      {children}
    </nav>
  );
};

Pagination.Truncate = function Truncate({ testId }: { testId?: string }) {
  return (
    <span
      className="flex size-5 items-center justify-center text-black"
      data-testid={testId}
      aria-hidden={true}
    >
      <RegularEllipsis size={14} />
    </span>
  );
};

Pagination.Button = function ({
  children,
  active,
  ariaLabel,
  asChild,
  disabled,
  ...props
}: {
  children: ReactNode;
  active?: boolean;
  ariaLabel: string;
  asChild?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>) {
  const Component = asChild ? Slot : 'button';

  return (
    <Component
      aria-label={ariaLabel}
      className={twJoin(
        'flex size-5 items-center justify-center rounded-sm border border-white bg-white text-black',
        disabled && 'cursor-not-allowed text-gray-600',
        !disabled &&
          'hover:border-blue-500 hover:text-blue-500 active:border-blue-500 active:text-blue-500 [&.active]:border-blue-500',
        active && '!border-blue-500 text-blue-500'
      )}
      disabled={disabled}
      aria-current={active ? 'page' : undefined}
      {...props}
    >
      {children}
    </Component>
  );
};

Pagination.NextIcon = function NextIcon() {
  return <RegularChevronRight size={16} />;
};

Pagination.PreviousIcon = function PreviousIcon() {
  return <RegularChevronRight size={16} className="rotate-180" />;
};
